"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpotlightIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
// eslint-disable-next-line css-modules/no-unused-class
const ConsumerNavIcon_module_css_1 = __importDefault(require("./ConsumerNavIcon.module.css"));
/**
 *
 */
function SpotlightIcon(props) {
    const baseClass = (0, clsx_1.default)(ConsumerNavIcon_module_css_1.default.icon, { [ConsumerNavIcon_module_css_1.default.active]: props.active });
    const pathClasses = (0, clsx_1.default)(ConsumerNavIcon_module_css_1.default.ba, ConsumerNavIcon_module_css_1.default.stroke);
    const titleId = "spotlight-icon-title";
    return ((0, jsx_runtime_1.jsxs)("svg", { width: "21", height: "23", viewBox: "0 0 21 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: baseClass, "aria-describedby": titleId, children: [(0, jsx_runtime_1.jsx)("title", { id: titleId, children: "Watch Snapchat Spotlight videos" }), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 2.35965C1.5 1.32355 2.6323 0.685338 3.51868 1.22183L18.6201 10.3622C19.4752 10.8797 19.4752 12.1203 18.6201 12.6378L3.51868 21.7782C2.6323 22.3147 1.5 21.6764 1.5 20.6404V2.35965Z", strokeWidth: "2", className: pathClasses })] }));
}
exports.SpotlightIcon = SpotlightIcon;
//# sourceMappingURL=SpotlightIcon.js.map